import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import "./Hero.css";

const Hero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <motion.div className="hero-content" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <motion.h1 className="hero-title" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
            Hola, soy <span className="highlight">Oscar Alvarez</span>
          </motion.h1>

          <motion.h2 className="hero-subtitle" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }}>
            Desarrollador Full Stack
          </motion.h2>

          <motion.p className="hero-description" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.6 }}>
            Apasionado por crear experiencias digitales únicas. Especializado en JavaScript, React, Dom, Node.js y tecnologías web modernas.
          </motion.p>

          <motion.div className="hero-buttons" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.8 }}>
            <button className="btn btn-primary" onClick={scrollToContact}>
              Contáctame
            </button>
            <button className="btn btn-secondary" onClick={() => document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" })}>
              Ver Proyectos
            </button>
          </motion.div>
        </motion.div>

        <motion.div className="hero-social" initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, delay: 1 }}>
          <a href="https://github.com/oscaralvarezrua" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://linkedin.com/in/oscaralvarezrua" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="mailto:oscaralvarez4c@gmail.com" className="social-link" aria-label="Email">
            <FaEnvelope />
          </a>
        </motion.div>
      </div>

      <div className="hero-background">
        <div className="gradient-1"></div>
        <div className="gradient-2"></div>
        <div className="gradient-3"></div>
      </div>
    </section>
  );
};

export default Hero;
